var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 8,
    viewBox: "0 0 15 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4133 0.683988L7.94768 6.06317C7.82843 6.18114 7.66745 6.24731 7.4997 6.24731C7.33195 6.24731 7.17097 6.18114 7.05172 6.06317L1.58615 0.685154C1.46616 0.567239 1.30465 0.501168 1.13642 0.501168C0.968186 0.501168 0.806682 0.567239 0.68669 0.685154C0.627603 0.742757 0.580644 0.811604 0.548582 0.887639C0.516519 0.963674 0.500001 1.04536 0.500001 1.12788C0.500001 1.2104 0.516519 1.29208 0.548582 1.36811C0.580644 1.44415 0.627603 1.513 0.68669 1.5706L6.1511 6.94861C6.51102 7.30201 6.99528 7.5 7.4997 7.5C8.00412 7.5 8.48838 7.30201 8.8483 6.94861L14.3127 1.5706C14.372 1.51298 14.4191 1.44406 14.4513 1.36792C14.4834 1.29177 14.5 1.20995 14.5 1.12729C14.5 1.04464 14.4834 0.962816 14.4513 0.886673C14.4191 0.81053 14.372 0.741609 14.3127 0.683988C14.1927 0.566073 14.0312 0.500001 13.863 0.500001C13.6947 0.500001 13.5332 0.566073 13.4133 0.683988Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdown);
export default __webpack_public_path__ + "static/media/dropdown.5b39e05fce5420c797c7ea07c9586473.svg";
export { ForwardRef as ReactComponent };